<template>
	<div>
		<div class="row mb-1">
			<div class="col-md-12">
				<BarCard title="SALES MODULAR (KL)" :data="salesdata" :width="500" :height="380" 
							:url="'/satgas/report?tab=0&station=' + station + '&date-range-start='+dtstart + '&date-range-end='+this.dtend + '&detail1=station&detail2=product&showchart=1'" :loading="loading.salesmodular" />
			</div>
		</div>
		<div class="row mb-1">
			<div class="col-md-12">
				<BarCard title="AVAILABLE STOCK (KL)" :data="tankStock" :width="500" :height="350" :tooltipaftertitle="this.aftertitlestock" :loading="loading.tankstock"
						:url="'/satgas/report?tab=3&station=' + station + '&date-range-start='+dtstart + '&date-range-end='+this.dtend + '&detail1=tank&detail2=product'"  />
			</div>
		</div>

		<div class="row">
			<div class="col-md-4 mb-4">
				<div class="card cardptpr">
					<div class="card-header p-3 pb-0 pt-0 text-center">
						<H6>PAYMENT METHODS (M)</H6>
					</div>
					<div class="card-body p-3 pt-0" style="width:100%;">
						<div class="h-100 d-flex align-items-center justify-content-center pt-2 pb-2 ">
							<PieChart :data="this.pieChartData()"  style="width:100%;" 
								:url="'/satgas/report?tab=2&station=' + station + '&date-range-start='+dtstart + '&date-range-end='+this.dtend + '&detail1=station&detail3=payment'"/>
							<div style="position:absolute;" v-if="paymentdata.length <= 0">No Data Available</div>
							<Loader v-if="loading.payment"/>
						</div>
					</div>
				</div>
			</div>

			<div class="col-md-4 mb-4">
				<div class="card cardptpr">
					<div class="card-header p-3 pb-0 pt-0 text-center">
						<H6>PAYMENT METHODS NON CASH (M)</H6>
					</div>
					<div class="card-body p-3 pt-0" style="width:100%;">
						<div class="h-100 d-flex align-items-center justify-content-center pt-2 pb-2 ">
							<PieChart :data="this.pieChartCashData()" style="width:100%;" 
								:url="'/satgas/report?tab=2&station=' + station + '&date-range-start='+dtstart + '&date-range-end='+this.dtend + '&detail1=station&detail3=payment'"/>
							<div style="position:absolute;" v-if="paymentcashdata.length <= 0">No Data Available</div>
							<Loader v-if="loading.paymentnoncash"/>
						</div>
					</div>
				</div>
			</div>

			<div class="col-md-4 mb-4">
				<div class="card cardptpr">
					<div class="card-header p-3 pb-0 pt-0 text-center">
						<H6>KONDISI PEKERJA (FIT & UNFIT)</H6>
					</div>
					<div class="card-body p-3 pt-0" style="width:100%;">
						<div class="h-100 d-flex align-items-center justify-content-center pt-2 pb-2 ">
							<PieChart :data="this.pieChartStatusPekerjaData()" style="width:100%;" />
							<div style="position:absolute;" v-if="piechartstatuspekerjadata.length <= 0">No Data Available</div>
							<Loader v-if="loading.piechartstatuspekerja"/>
						</div>
					</div>
				</div>
			</div>

		</div>

		<div class="row mb-4" v-if="this.salesbbkkemasansatgas.length > 0">
			<div class="col-md-12">
				<BarCard title="SALES BBK KEMASAN" :data="salesbbkkemasansatgas" :width="500" :height="400"/>
			</div>
		</div>

		<!--
		<div class="row mb-4">
			
			<div class="col-md-6">
				<h4>ATG</h4>
				<div class="row col-md-12" style="padding-left:0px;">
					<div class="col-md-6">
						<BarCard title="Volume Minyak (ℓ)" :data="atgVolume" :width="500" :height="300"/>
					</div>
					<div class="col-md-6">
						<table class="table table-striped">
							<tbody>
							<tr>
								<th colspan="2">Keterangan :</th>
							</tr>
							<tr>
								<th>Tank</th>
								<td>{{ this.atg.atgstatus.Id_Tank }}</td>
							</tr>
							<tr>
								<th>Status ATG</th>
								<td>Online</td>
							</tr>
							<tr>
								<th>Last Update</th>
								<td>{{ this.atg.atgstatus.Last_Update }}</td>
							</tr>
							<tr>
								<th>Tinggi Minyak</th>
								<td>{{ atg.atgstatus.Tinggi_Oil }} mm</td>
							</tr>
							<tr>
								<th>Volume Minyak</th>
								<td>{{ atg.atgstatus.Volume_Oil }} ℓ</td>
							</tr>
							<tr>
								<th>Max Volume</th>
								<td>{{ atg?.atgstatus?.MaxVolume ?? "-" }} ℓ</td>
							</tr>
							<tr>
								<th>Tinggi Air</th>
								<td>{{ atg.atgstatus.Tinggi_Air }} mm</td>
							</tr>
							<tr>
								<th>Volume Air</th>
								<td>{{ atg.atgstatus.Volume_Air }} ℓ</td>
							</tr>
							<tr>
								<th>Temperatur</th>
								<td>{{ atg.atgstatus.Volume_Air }} ° Celcius</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			
			
			<div class="col-md-6">	
				<h4>Penjualan H-2 s/d Hari ini (ℓ)</h4>
				<BarCard title="Penjualan H-2" :data="lastTwoDaysSales" :width="500" :height="280"/>
			</div>
		</div>
		-->

		<!--
		<div class="row mb-4">
			<h4>Shift</h4>
			<ReportResultTable reportname="shift" :reportdata="shiftdata" />
		</div>

		<div class="row mb-4">
			<h4>Transaksi</h4>
			<ReportResultTable reportname="transaksi" :reportdata="transactiondata" />
		</div>
		-->

		<!--
		<div class="row mb-4">
			<h4>Penerimaan BBM</h4>
			<ReportResultTable reportname="perenimaan_bbm" :reportdata="deliverydata" />
		</div>

		<div class="row mb-4">
			<h4>Arus Minyak</h4>
			<ReportResultTable reportname="arus_minyak" :reportdata="shiftflowdata" />
		</div>
		-->

		<div class="row mb-3 mt-0">
			<div class="col-md-12">
				<div class="card cardptpr mb-4">
					<div class="card-header p-3 pb-0 pt-0">
						<H6>STATUS PEKERJA</H6>
					</div>
					<div class="card-body p-3 pt-0">
						<ReportResultTable reportname="AbsenPekerja" :reportdata="reportdata" :loading="loading.statuspekerja" />
					</div>
				</div>	
			</div>
		</div>

	</div>
</template>

<script>
import BarCard from '@/views/pages/BarCard.vue'
import Fuel from '@/components/page/Fuel.js'
import PieChart from '@/components/chart/Pie.js'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import { Config, AxiosWithJar, Rainbow, FuelColor } from '@/utility.js' //Penanggalan, 
import Loader from '@/components/loader/Loader2.vue'


export default{
	extends: Fuel,
	components:{
		ReportResultTable,
		BarCard,
		PieChart,
		Loader,
	},
    data() {
		return {
			salesdata:[],
			reportdata:[],
			paymentdata:[],
			paymentcashdata:[],
			salesbbkkemasansatgas:[],
			shiftdata:[],
			transactiondata:[],
			deliverydata:[],
			shiftflowdata:[],
			//pieChartStatusPekerja: [],
			piechartstatuspekerjadata: [],
			
			atg:{
				atgstatus: {},
				transaction : {},
			},
			dtstart:'',
			dtend:'',
			loading: {
				salesmodular: true,
				payment: true,
				paymentnoncash: true,
				statuspekerja: true,
				piechartstatuspekerja: true,
			}
		}
	},
    mounted(){
		this.$nextTick(function(){
			this.loadYTD(1);
			this.loadTankStock(1);
			this.getSatgasTitle()
			this.summarySatgas(this.$route.query.station);	
			this.getStatusPekerjaFitUnfit()	
		})
    },
	computed: {

		tankStock() {
			let data = [];
			for (let i=0;i<this.stock.tank.length;i++) {
				let dt2 = {};
				dt2.TankName = this.stock.tank[i].TankName;
				dt2.ProductName = this.stock.tank[i].ProductName;
				dt2.Volume = this.stock.tank[i].FuelVolume;
				data.push(dt2);

				/*
				//for additional tooltip info
				let tooltipitem = [];
				tooltipitem.push("Status: "+this.stock.tank[i].StatusATG);
				tooltipitem.push("Last Update: "+this.stock.tank[i].LastUpdate2);
				this.aftertitlestock.push(tooltipitem);
				*/
				
			}
			for (let i=0;i<this.stock.tank.length;i++) {
				let dt2 = {};
				dt2.TankName = this.stock.tank[i].TankName;
				dt2.ProductName = "ULLAGE";
				dt2.Volume = this.stock.tank[i].Ullage;
				data.push(dt2);
			}
			//console.log("aftertitlestock: "+JSON.stringify(this.aftertitlestock));
			//console.log(data);
			let result = this.processBarChart2(data, 'ProductName', 'Volume', false, 'TankName', 1000, 2, FuelColor, 
						false, false, false, true, false, false, false, false, true);
			//console.log(JSON.stringify(result));
			return result;
		},
		
		atgVolume() {
			const Color = {
				"Volume Minyak": "#2e5bfe",
			};
			let data = [];
			let dt2 = {}
				dt2.TankName = this.atg.atgstatus.Id_Tank;
				dt2.ProductName = "Volume Minyak";
				dt2.Volume = this.atg.atgstatus.Volume_Oil;
				data.push(dt2);
			return this.processBarChart2(data, 'ProductName', 'Volume', false, 'TankName', 1, 2, Color, 
						false, false, false, true, false, false, false, false, true);
		},
		lastTwoDaysSales() {
			const Color = {
				"Total Penjualan": "#2e5bfe",
			};
			let data = [];
			let dt2 = {}
				dt2.TankName = "Penjualan";
				dt2.ProductName = "Total Penjualan";
				dt2.Volume = this.atg.transaction.Total_Volume;
				data.push(dt2);
			return this.processBarChart2(data, 'ProductName', 'Volume', false, 'TankName', 1, 2, Color, 
						false, false, false, true, false, false, false, false, true);
		}
	},
	watch: {

	},
    methods:{
		async getSatgasTitle() {
			//GET SATGAS TITLE
			let url =Config().apiURL + '/v1/fuel2/satgastitle?'
			AxiosWithJar().get(url)
			.then((response)=>{ 
				this.dtstart = response.data.data[0].START_DATE;
				this.dtend = response.data.data[0].END_DATE;
			})
			.catch(error => {
				//console.log('err: ' + error)
			})
			.finally(() => {
				//this.loading.salesmodular = false;
			})
		},

		async getStatusPekerjaFitUnfit() {
			//GET STATUS PEKERJA FIT & UNFIT
			let station = this.$route.query.station
			let url =Config().apiURL + '/v1/vendor/absentkjppiechart?'
			url +='&station='+station    
			this.loading.piechartstatuspekerja = true
			AxiosWithJar().get(url)
			.then((response)=>{ 
				if(response.data.data) {
					//console.log(JSON.stringify(response.data))
					let data = response.data.data
					this.piechartstatuspekerjadata = data
				}
			})
			.catch(error => {
				//console.log('err: ' + error)
			})
			.finally(() => {
				//this.loading.salesmodular = false;
				this.loading.piechartstatuspekerja = false
			})
		},

        async summarySatgas(station){
			this.dtstart = '2022-12-19'; // '2022-04-18'
			this.dtend = '2023-01-31'; //Penanggalan().kemarin
		
			let url =Config().apiURL+"/v1/Bright/salesbbksatgas?period=daily&detail=product&modular="+station
				url += "&date-range-start="+this.dtstart
				url += "&date-range-end="+this.dtend
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data){
					this.salesbbkkemasansatgas = this.processBarChart(result.data.data, "ItemName", "", "Qty", false, "Period", " ", 1, 2, Rainbow);
					//console.log("reportdata Load from backend:: "+JSON.stringify(this.salesbbkkemasansatgas));			
				}
			})
			
			//Sales Modular KL
			//url =Config().apiURL+"/v1/fuel2/sales?period=daily&detail=product&satgas=1"
			url =Config().apiURL+"/v1/fuel2/saleschartmodular?period=daily&detail=product&satgas=1"
				url += "&date-range-start="+this.dtstart
				url += "&date-range-end="+this.dtend
				url += (this.station ? "&station=" + this.station : "");								
			
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data){
					this.salesdata = this.processBarChart2(result.data.data, 'ProductName', 'SalesVolume', false, 'Period', 1000, 2, FuelColor, 
						false, false, false, true, false, false, false, true)
						//console.log("reportdata Load from backend:: "+JSON.stringify(this.salesdata));	
				}
			})
			.catch(error => {
				//console.log('err: ' + error)
			})
			.finally(() => {
				this.loading.salesmodular = false;
			})

			//Payment cash/non cash (Pie Chart)
			this.loading.payment = true;
			url =Config().apiURL+"/v1/fuel2/payment?detail=cash&satgas=1"
				url += "&date-range-start="+this.dtstart
				url += "&date-range-end="+this.dtend
				url += (this.station ? "&station=" + this.station : "");								
			
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data){
					this.paymentdata = result.data.data;	
				}
			})
			.catch(error => {
				//console.log('err: ' + error)
			})
			.finally(() => {
				this.loading.payment = false;
			})

			//Payment cash only (Pie Chart)
			this.loading.paymentnoncash = true;
			url =Config().apiURL+"/v1/fuel2/paymentcashmodular?detail=cash&satgas=1"
				url += "&date-range-start="+this.dtstart
				url += "&date-range-end="+this.dtend
				url += (this.station ? "&station=" + this.station : "");								
			
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data){
					this.paymentcashdata = result.data.data;	
				}
			})
			.catch(error => {
				//console.log('err: ' + error)
			})
			.finally(() => {
				this.loading.paymentnoncash = false;
			})

            this.urlRequestParams=Config().apiURL			
			this.urlRequestParams+='/v1/vendor/absentkjp?'
			
            this.urlRequestParams+='&station='+station         

			this.loading.statuspekerja = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                this.reportdata = response.data;
				//console.log("reportdata Load from backend:: "+JSON.stringify(this.reportdata));
            })
			.catch(error => {
				//console.log('err: ' + error)
			})
			.finally(() => {
				this.loading.statuspekerja = false;
			})
			

			/*
			url = Config().apiURL+"/v1/plant/shift?"
				url += "limit=50"
				url += (this.station ? "&station=" + this.station : "");	
			AxiosWithJar().get(url)
            .then((response)=>{ 
                this.shiftdata = response.data;
				//console.log("reportdata Load from backend:: "+JSON.stringify(this.reportdata));
            })
			*/

			url = Config().apiURL+"/v1/plant/transaction?"
				url += "limit=50"
				url += (this.station ? "&station=" + this.station : "");
			AxiosWithJar().get(url)
            .then((response)=>{ 
                this.transactiondata = response.data;
				//console.log("reportdata Load from backend:: "+JSON.stringify(this.reportdata));
            })

			url = Config().apiURL+"/v1/plant/delivery?"
				url += "limit=50"
				url += (this.station ? "&station=" + this.station : "");
			AxiosWithJar().get(url)
            .then((response)=>{ 
                this.deliverydata = response.data;
				//console.log("reportdata Loaded from backend:: "+JSON.stringify(this.reportdata));
            })

			url = Config().apiURL+"/v1/plant/flow?"
				url += "limit=50"
				url += (this.station ? "&station=" + this.station : "");
			AxiosWithJar().get(url)
            .then((response)=>{ 
                this.shiftflowdata = response.data;
				//console.log("reportdata Load from backend:: "+JSON.stringify(this.reportdata));
            })

			url = Config().apiURL+"/v1/plant/atgstatus?"
				url += (this.station ? "station=" + this.station : "");
			AxiosWithJar().get(url)
            .then((response)=>{ 
                this.atg.atgstatus = response.data.atgstatus[0];
				this.atg.transaction = response.data.transaction[0];
				//console.log('this.atg.atgstatus: '+ JSON.Stringify(response));
				//console.log("%j", response);
				//console.log("reportdata Load from backend:: "+JSON.stringify(this.reportdata));
            })

			/*
			this.loading.table = true;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.reportdata = response.data;
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})
				*/
        },
		
		pieChartData()
        {
			var warna=[]
			warna["NON CASH"]='#FF2E51' //'rgba(255,0,0,1)'
			warna["CASH"]= '#2E5BFE' //rgba(0,0,255,1)'				

			return this.processPieChart(this.paymentdata, "Amount", "TransactionType", 1000000, 2, warna); 
        },
		
		pieChartCashData()
        {
			var warna=[]
			let data = this.paymentcashdata
			for (let i = 0; i < data.length; i++) {
				warna[data[i].Tipe] = Rainbow[i];
			}
			return this.processPieChart(this.paymentcashdata, "Amount", "Tipe", 1000000, 2, warna); 
        },

		pieChartStatusPekerjaData()
        {
			var warna=[]
			let data = this.piechartstatuspekerjadata
			for (let i = 0; i < data.length; i++) {
				warna[data[i].Condition] = Rainbow[i];
			}
			//console.log(JSON.stringify(data))
			return this.processPieChart(this.piechartstatuspekerjadata, "cnt", "Condition", 1, 2, warna); 
        },
	}
}

</script>